import React, { type ReactNode } from "react";
import DeleteConfirmModalBase from "./DeleteConfirmModalBase";

export interface ConfirmDeleteModalProps {
  open: boolean;
  title: string;
  supportingText: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  primaryLabel?: string;
}

export default function ConfirmDeleteModal({
  open,
  title,
  supportingText,
  onClose,
  onConfirm,
  primaryLabel,
}: ConfirmDeleteModalProps) {
  return (
    <DeleteConfirmModalBase
      open={open}
      title={title}
      supportingText={supportingText}
      onClose={onClose}
      onConfirm={onConfirm}
      primaryLabel={primaryLabel}
    />
  );
}
